<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-file-csv"
          size="fa-lg"
          id="btn_generate_csv_roteirizations"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <Roteirization />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import Roteirization from '@/components/reports/roteirizations/Roteirization'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Roteirizations',
  components: {
    PageTitle,
    PageRowWrapper,
    Roteirization,
    ActionButton
  }
}
</script>
